<template>
  <v-list>
    <template v-for="(field, index) in fields">
      <v-divider
        v-if="index === 0"
        :key="`div-top-${index}`"
      />
      <v-list-item
        :key="field.id"
        dense
        @click.prevent.stop="$emit('edit-field', field, index)"
      >
        <v-list-item-title
          class="font-weight-medium"
        >
          {{ field.default_translation.label }} {{ field.required ? '*' : '' }} ({{ field.type }})
        </v-list-item-title>
        <v-list-item-action>
          <v-btn
            :ref="`field-${field.id}-move-up`"
            icon
            small
            @click.prevent.stop="$emit('move-field-up', field, index)"
          >
            <v-icon>
              mdi-arrow-up
            </v-icon>
          </v-btn>
        </v-list-item-action>
        <v-list-item-action>
          <v-btn
            icon
            small
            @click.prevent.stop="$emit('move-field-down', field, index)"
          >
            <v-icon>
              mdi-arrow-down
            </v-icon>
          </v-btn>
        </v-list-item-action>
        <v-list-item-action class="pl-2">
          <v-btn
            icon
            small
            @click.prevent.stop="$emit('delete-field', field, index)"
          >
            <v-icon>
              mdi-delete
            </v-icon>
          </v-btn>
        </v-list-item-action>
        <v-list-item-action>
          <v-btn
            ref="btn"
            icon
            small
            @click.prevent.stop="$emit('edit-field', field, index)"
          >
            <v-icon>mdi-cog</v-icon>
          </v-btn>
        </v-list-item-action>
      </v-list-item>
      <v-divider :key="`div-bottom-${index}`" />
    </template>
    <template v-if="fields.length === 0">
      <v-divider />
      <v-list-item>
        <p class="font-italic mb-0">
          {{ $t('No input fields added') }}
        </p>
      </v-list-item>
      <v-divider />
    </template>
  </v-list>
</template>

<script>
export default {
  props: {
    fields: {
      type: Array,
      required: true
    }
  },
}
</script>